module.exports = __webpack_public_path__ + "img/hero-1-min.3c9f4813.jpg";